import { eventBus } from '~/utils/adapi';

export default {
  data() {
    return {
      isError: false,
      count: 0,
    };
  },
  methods: {
    requestFinished(error = false) {
      this.count -= 1;

      if (error) {
        this.isError = true;
      }

      if (this.count > 1) {
        this.$nprogress.inc();
      } else {
        this.$nprogress.done();
      }
    },
  },
  mounted() {
    eventBus
      .$on('start', () => {
        if (!this.count) {
          this.isError = false;
        }

        this.count += 1;
        this.$nprogress.start();
      })
      .$on('done', () => this.requestFinished())
      .$on('error', () => this.requestFinished(true));
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/progress-bar/ProgressBar.js